<script>
    import { createEventDispatcher, empty } from "svelte/internal";
    import AddReward from "./AddReward.svelte";
    import Reward from "./Reward.svelte";

    export let rewards = [];
    export let type;

    const dispatch = createEventDispatcher();

    function add (e) {
        rewards.push(e.detail);
        rewards = rewards;
        dispatch("save");
    }

    function edit (e) {
        console.log(rewards);
        dispatch("save");
    }

    function remove (e) {
        rewards = rewards.filter((reward) => {return reward.id !== e.detail.id});
        dispatch("save");
    }
</script>

<b>
    {#if type === "all"}
        Alle folgenden Belohungen:
    {:else if type === "choice"}
        Eine der folgenden Belohungen:
    {:else if type === "lottery"}
        Gewinnchance auf:
    {/if}
</b><br>
<div class="rewards">
    {#if rewards.length > 0}
        {#each rewards as reward, i (reward.id)}
            <Reward {type} bind:reward={reward} on:edit={edit} on:remove={remove}/>
        {/each}
    {:else}
        <span class="empty">Keine Belohnungen eingetragen</span>
    {/if}
    <AddReward {type} on:add={add}/>
</div>

<style>
    .rewards {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .empty {
        font-style: italic;
        color: #968f89;
    }
</style>